<template>
  <v-card>
    <v-card-title primary-title>
      Ta bort definition
    </v-card-title>

    <v-card-text>
      <p>
        Är du säker på att du vill ta bort definitionen:
      </p>
      <strong>
        Tågnummer serie: {{ definition.train_number_from }} -
        {{ definition.train_number_to }}
      </strong>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn tile text @click="close" :disabled="pendingDelete">
        Avbryt
      </v-btn>
      <v-btn
        tile
        color="error"
        text
        @click="deleteDefinition"
        :loading="pendingDelete"
      >
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'DefinitionDelete',

  props: {
    definition: Object
  },

  data: () => ({
    pendingDelete: false
  }),

  methods: {
    close() {
      this.$emit('close')
    },

    async deleteDefinition() {
      this.pendingDelete = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation deleteDefinition($id: Int!) {
            deleteDefinition(id: $id)
          }
        `,

        variables: {
          id: parseInt(this.definition.id, 10)
        }
      })

      this.pendingDelete = false
      this.$emit('confirm')
    }
  }
}
</script>
